<canvas #processPerformancePie width="{{width}}" height="{{width}}"></canvas>
